import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendVerificationCode } from 'services/pod';
import { ISendVerificationCodePayload } from 'services/pod/types';
import { fixPhoneFormat } from 'services/common/common.service';
import { ICommonResponse } from 'services/types';
import { ISendErrorPayload, extractSendErrorPayload } from './sendErrorPayload';

export const ThunkSendVerificationCode = createAsyncThunk<
  ICommonResponse<string>,
  ISendVerificationCodePayload,
  { rejectValue: ISendErrorPayload }
>('pod/sendVerificationCode', async (data, { rejectWithValue }) => {
  try {
    if (data?.phoneNumber) {
      const formatted = await fixPhoneFormat(data.phoneNumber);
      if (!formatted?.data?.data) {
        return rejectWithValue({ handled: true });
      }
      const r = await sendVerificationCode({ ...data, phoneNumber: formatted.data.data });
      return r.data;
    }

    const r = await sendVerificationCode(data);
    return r.data;
  } catch (err) {
    return rejectWithValue(extractSendErrorPayload(err));
  }
});
